import {gql} from '@apollo/client'
import {Flow, FlowGenerator, UseFlowQuery} from 'features/procedures/Flow/Flow'
import {maybeYieldChildcareMethodSelect} from 'features/procedures/Flow/helpers'
import {useQuery} from 'hooks/graphql'

const FINISH_CHILDCARE_FLOW_QUERY = gql`
  query FinishChildcareFlowQuery($procedureStatusId: ID!) {
    client {
      id
      procedureStatus(procedureStatusId: $procedureStatusId) {
        id
        employee {
          id
          healthInsurance {
            id
            joined
          }
          welfarePensionInsurance {
            id
            joined
          }
          currentOffice {
            id
            healthInsuranceType
          }
          pastChildcareProcedureStatuses(forProcedureType: finish_childcare) {
            id
          }
        }
        childcareMethodSelect: procedureTmpDatum(type: draft, name: "childcare_method_select") {
          id
        }
      }
    }
  }
`

interface FlowQueryData {
  client: {
    id: string
    procedureStatus: {
      id: string
      employee: {
        id: string
        healthInsurance?: {
          id: string
          joined: boolean
        }
        welfarePensionInsurance?: {
          id: string
          joined: boolean
        }
        currentOffice: {
          id: string
          healthInsuranceType: 'kyokai' | 'its' | 'other'
        }
        pastChildcareProcedureStatuses: {id: string}[]
      }
      childcareMethodSelect?: {
        id: string
      }
    }
  }
}

const useFlowQuery: UseFlowQuery<FlowQueryData> = ({procedureStatusId}) => {
  return useQuery<FlowQueryData>(FINISH_CHILDCARE_FLOW_QUERY, {
    variables: {procedureStatusId},
    fetchPolicy: 'network-only',
  })
}

const makeFlow: FlowGenerator<FlowQueryData> = function* (data, _flowStatus, flowMode) {
  const procedureStatus = data.client.procedureStatus
  const employee = procedureStatus.employee
  const healthInsuranceJoined = employee.healthInsurance?.joined
  const welfarePensionInsuranceJoined = employee.welfarePensionInsurance?.joined
  const healthInsuranceType = employee.currentOffice.healthInsuranceType

  yield* maybeYieldChildcareMethodSelect({
    flowMode,
    pastChildcareCount: employee.pastChildcareProcedureStatuses.length,
    methodSelectExists: !!procedureStatus.childcareMethodSelect,
  })

  // ChildcareInfoForm は mode='new' でも必要なため常に yield
  yield 'ChildcareInfo'

  if (healthInsuranceType === 'kyokai' || healthInsuranceType === 'other') {
    if (healthInsuranceJoined || welfarePensionInsuranceJoined) {
      yield 'R507'
    }
  } else if (healthInsuranceType === 'its') {
    if (healthInsuranceJoined || welfarePensionInsuranceJoined) {
      yield 'R508'
    }
  }

  yield 'Attachments'
}

export const FinishChildcareFlow = () => (
  <Flow procedureContext="admin" makeFlow={makeFlow} useFlowQuery={useFlowQuery} />
)
